module.exports = __webpack_public_path__ + "img/ghIcon3.6573c018.png";